import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.LeaseContractLengths1,
  LocationVarKey.LeaseContractLengths2,
  LocationVarKey.LeaseContractLengths3,
  LocationVarKey.LeaseContractLengths4
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Contract Lengths
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.LeaseContractLengths1} />
      <TextAreaRow {...page} marginTop label=" Message 2" keyName={LocationVarKey.LeaseContractLengths2} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 3 (Optional)"
        keyName={LocationVarKey.LeaseContractLengths3}
        enableSwitchVar={LocationVarKey.LeaseContractLengths3Enabled}
      />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 4 (Optional)"
        keyName={LocationVarKey.LeaseContractLengths4}
        enableSwitchVar={LocationVarKey.LeaseContractLengths4Enabled}
      />
    </>
  );
}
